import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { GridOptions } from 'ag-grid-community';
import { InvoicesService } from 'src/app/service/document-control/invoices.service';
import { ExportStateService } from 'src/app/service/export-state.service';
import { ExcelService } from 'src/app/service/excel.service';
import { RowGroupingModule } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    standalone: false
})
export class InvoicesComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  public getRowStyle: any;
  icons;
  context: any;
  dynamicHeight
  detailCellRendererParams;
  // public modules = AllModules;
  public modules = [
    RowGroupingModule
  ];

  @ViewChild('agGrid', { static: true }) agGrid: GridOptions
  // gridOptions: any = { detailRowHeight: 64, enableCellTextSelection : true };
  temprowData2;
  temprowData: any;
  gridColumnApi: any;
  isAccessible = false;
  gridOptions: GridOptions = {
    detailRowAutoHeight: false,
    detailRowHeight: 64,
    enableCellTextSelection: true,
    masterDetail: true}
  paginationPageSize: number = 20;
	setPagination = 'true';
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]

  constructor(private readonly router: Router, private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly invoicesService: InvoicesService, private readonly exportStateService: ExportStateService, private readonly excelService: ExcelService) {

  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.columnDefs = [
      {
        headerName: "INVOICE NUMBER", field: "invoiceNum", width: 150, cellRenderer: 'agGroupCellRenderer', suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', cellStyle: { 'padding-top': '6px' }, unSortIcon: true, sortable: true,
      },
      {
        headerName: "SHIPMENT ID", field: "shipment_id", width: 150, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "MODE", field: "shipment_type", width: 200, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "IT BOND", field: "it", width: 300, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "BA#/214", field: "ba214", width: 250, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "T & E", field: "tande", width: 220, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      }];

    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            headerName: "SUPPLIER", field: "supplier", width: 50,
          },
          {
            headerName: "SHIPMENT DATE", field: "shipmentDate", width: 50,
          },
          {
            headerName: "TYPE", field: "type", width: 50
          },
          {
            headerName: "SETS", field: "sets", width: 20
          },
          {
            headerName: "PALLETS", field: "pallets", width: 30
          },
          {
            headerName: "GROSS KG", field: "gross", width: 20
          },
          {
            headerName: "NET KG", field: "net", width: 20
          },
          {
            headerName: "TARE KG", field: "tare", width: 20
          },
          {
            headerName: "VALUE", field: "value", width: 20,
          }
        ],
        defaultColDef: { flex: 1 },
      },

      getDetailRowData: function (params) {
        params.successCallback(params.data.subtaskRecords);
      },
    };
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    // this.checkRoles();
    this.RefreshData();
    
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }


  RefreshData() {

    this.context = {
      componentParent: this
    };

    this.temprowData = [];
    this.temprowData2 = [];

    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.invoicesService.loadInvoicesData().subscribe(result => {

      if (result?.length > 0) {
        this.temprowData = result;
        this.temprowData.forEach(element => {

          const obj = {
            "ba214": undefined,
            "invoiceNum": undefined,
            "it": undefined,
            "shipment_id": undefined,
            "shipment_type": undefined,
            "tande": undefined,
            "subtaskRecords": [],
            "page": undefined
          };
          obj.ba214 = element.ba214;
          obj.invoiceNum = element.invoiceNum;
          obj.it = element.it;
          obj.shipment_type = element.shipment_type;
          obj.shipment_id = element.shipment_id;
          obj.tande = element.tande;
          obj.page = "InvoicesComponent";

          if (
  element.supplier ||
  element.shipmentDate ||
  element.freightType ||
  element.sets ||
  element.pallets ||
  element.grossWeight ||
  element.netWeight ||
  element.tareWeight ||
  element.partValue
) {

  obj.subtaskRecords.push({
    "supplier": element.supplier,
    "shipmentDate": element.shipmentDate,
    "type": element.freightType,
    "sets": element.sets,
    "pallets": element.pallets,
    "gross": element.grossWeight,
    "net": element.netWeight,
    "tare": element.tareWeight,
    "value": element.partValue
  });

}

          this.temprowData2.push(obj);
        });

        this.displayRowData = this.temprowData2;
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
      }
      else {
        this.displayRowData = [];
        this.errorMessage = 'No Invoice Data is associated with Shipments';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    }, _error => { this.ngxUiLoaderService.stop(this.constants.LoaderComponent) });
  }


  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  onGridSizeChanged(params: any) {
    params.api.sizeColumnsToFit();
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridColumnApi = params.columnapi;
    this.gridApi.sizeColumnsToFit();
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const headers = ['Invoice Number', 'Shipment ID', 'Shipment Type', 'IT Bond', 'BA#/214', 'T & E', 'Supplier',
        'Shipment Date', 'Type', 'Sets', 'Paleets', 'Gross KG', 'Net KG', 'Tare KG', 'Value'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
        {linkData = this.displayRowData}
      linkData.forEach(e => {
        const obj = {
          invoiceNum: e.invoiceNum,
          shipment_id: e.shipment_id,
          shipment_type: e.shipment_type,
          it: e.it,
          ba214: e.ba214,
          tande: e.tande,
          supplier: e.subtaskRecords[0].supplier,
          shipmentDate: e.subtaskRecords[0].shipmentDate,
          freightType: e.subtaskRecords[0].type,
          sets: e.subtaskRecords[0].sets,
          pallets: e.subtaskRecords[0].pallets,
          gross: e.subtaskRecords[0].gross,
          net: e.subtaskRecords[0].net,
          tare: e.subtaskRecords[0].tare,
          value: e.subtaskRecords[0].value
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'INVOICES ', headers);

    }
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

}
